import { FilterConfig } from '@/types/filter';
import { FilterValue } from '@/models';

import { HCP_SCIENTIFIC_ACTIVITY_GUIDELINE } from '@/api/hcp';

import Stars from '@/components/shared/rating/Stars/Stars';

const guidelineFilter: FilterConfig = {
  label: 'global.filters.formControls.guidelineLabel',
  placeholder: 'global.filters.formControls.guidelinePlaceholder',
  defaultValue: null,
  type: 'levelselect',
  format: ({ value, t }) => (
    <>
      <span>{t('global.filters.guideline')}</span>
      <Stars value={Number(value)} />
    </>
  ),
  filterGroup: 'scientificActivities',
  applyFilter: (filterValue: FilterValue) => {
    const ratingScore = Number(filterValue) || 0;
    return {
      and: [
        {
          member: `${HCP_SCIENTIFIC_ACTIVITY_GUIDELINE}.score_label`,
          operator: 'equals',
          values: ['national score'],
        },
        {
          member: `${HCP_SCIENTIFIC_ACTIVITY_GUIDELINE}.score_value`,
          operator: 'gte',
          values: [ratingScore.toString()],
        },
      ],
    };
  },
};

export default guidelineFilter;
